import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CartSettingContent, CartSettingSwitchItem, CartSettingSwitchWrap, CartSettingTitle } from '../index.styled'
import SwitchInputControlled from '../../../Elements/inputs/SwitchInput/controlled'
import { DELIVERY_MODULE } from '../../constants'
import { updateDeliveryBeeperConfigsThunk } from '../../../../redux/thunk/deliverySettings'

const DeliveryBeeperSettings = React.memo(() => {
	const { t } = useTranslation()
	const beeperConfigs = useSelector(store => store.deliverySettings.beeperConfigs)
	const dispatch = useDispatch()
	const beeperEnabled = beeperConfigs?.beeperEnabled
	const beeperRequired = beeperConfigs?.beeperRequired

	const changeBeeperEnabledSetting = useCallback((e) => {
		dispatch(updateDeliveryBeeperConfigsThunk({
			module: DELIVERY_MODULE,
			beeperEnabled: e.target.checked,
			beeperRequired,
		}))
	}, [dispatch, beeperRequired])

	const changeBeeperRequiredSetting = useCallback((e) => {
		dispatch(updateDeliveryBeeperConfigsThunk({
			module: DELIVERY_MODULE,
			beeperEnabled,
			beeperRequired: e.target.checked,
		}))
	}, [dispatch, beeperEnabled])


	return (
		<CartSettingContent>
			<CartSettingTitle>{t('Settings.beeperSettings.title')}</CartSettingTitle>
			<CartSettingSwitchWrap className="beeper">
				<CartSettingSwitchItem className={beeperEnabled ? 'active' : ''}>
					<SwitchInputControlled name="beeper-enabled"
																 testId="beeper-enabled"
																 checked={beeperEnabled}
																 onChange={changeBeeperEnabledSetting}
																 label={t('Settings.beeperSettings.beeperEnabled')} />
				</CartSettingSwitchItem>
				<CartSettingSwitchItem className={beeperRequired ? 'active' : ''}>
					<SwitchInputControlled name="beeper-required"
																 testId="beeper-required"
																 checked={beeperRequired}
																 onChange={changeBeeperRequiredSetting}
																 label={t('Settings.beeperSettings.beeperRequired')} />
				</CartSettingSwitchItem>
			</CartSettingSwitchWrap>
		</CartSettingContent>
	)
})

DeliveryBeeperSettings.displayName = 'DeliveryBeeperSettings'
export default DeliveryBeeperSettings
